import title from "./assets/title.png";
import still1 from "./assets/still1.jpg";
import still2 from "./assets/still2.jpg";
import tweet_mid from "./assets/tweet_mid.png";
import tweet_left from "./assets/tweet_left.png";
import tweet_right from "./assets/tweet_right.png";
import videoUrl from "./assets/teaser.mp4";
import "./teaser.scss";
import { useState } from "react";
import FsLightbox from "fslightbox-react";
import { fade, childFade } from "../fade.js";
import { motion } from "framer-motion";

const Teaser = (props) => {
  const [controller, setController] = useState({ t: false, s: 1 });

  return (
    <section class="section teaser">
      <motion.img
        src={title}
        alt="Teasing the gang's arrival"
        className="title"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      />
      <motion.p
        className="copy"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        To tease and create hype for what was about to hit Indonesian fans, we
        plastered the city with ominous billboards that showcased the names of
        cities and their actual times, as a reference to the characters on the
        show.
      </motion.p>
      <motion.video
        controls
        className="teaser-video"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <source src={videoUrl} type="video/mp4" />
      </motion.video>
      <motion.div
        className="stills"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <motion.img
          src={still1}
          alt="Still 1"
          onClick={() => setController({ t: !controller.t, s: 1 })}
          variants={childFade}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
        />
        <img
          src={still2}
          alt="Still 2"
          onClick={() => setController({ t: !controller.t, s: 2 })}
          variants={childFade}
          initial="hide"
          viewport={{ once: true }}
          whileInView="show"
        />
        <FsLightbox
          toggler={controller.t}
          sources={[still1, still2]}
          slide={controller.s}
        />
      </motion.div>
      <motion.div
        className="tweets"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <motion.img
          src={tweet_left}
          alt="Tweet from Twitter"
          className="left"
          variants={childFade}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
        />
        <motion.img
          src={tweet_mid}
          alt="Tweet from Twitter"
          className="mid"
          variants={childFade}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
        />
        <motion.img
          src={tweet_right}
          alt="Tweet from Twitter"
          className="right"
          variants={childFade}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
        />
        <p className="disclaimer">Translated for context</p>
      </motion.div>
    </section>
  );
};

export default Teaser;
